import React from 'react';
import connect from 'react-redux/es/connect/connect';
import { TagsInputWrapper } from 'react-lib/dist/components-es';

const CommonTagsInputWrapper = props => {
  if (props.customFilteredSuggestions) {
    return <TagsInputWrapper {...props} filteredSuggestions={props.customFilteredSuggestions} />;
  } else {
    return <TagsInputWrapper {...props} />;
  }
};

const mapStateToProps = state => ({
  ...state.lazyAutocomplete,
});

export default connect(mapStateToProps, null)(CommonTagsInputWrapper);
